import { useState } from 'react';

import { cn } from '@shared/lib';

import { KNOWN_COIN_ICONS } from './coin-icon-list';

interface CoinIconProps {
  code: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE_MAP = {
  xs: 'w-3.5 h-3.5',
  sm: 'w-5 h-5',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
} as const;

const FALLBACK_SRC = '/images/no_icon_image.svg';

export const CoinIcon = ({ code, size = 'md', className }: CoinIconProps) => {
  const lowerCode = code.toLowerCase();
  const hasIcon = KNOWN_COIN_ICONS.has(lowerCode);
  const [failed, setFailed] = useState(false);
  const sizeClass = SIZE_MAP[size];

  return (
    <img
      src={!hasIcon || failed ? FALLBACK_SRC : `/images/coin/${lowerCode}.svg`}
      alt={code.toUpperCase()}
      className={cn(sizeClass, 'rounded-full object-cover', className)}
      onError={() => { if (!failed) setFailed(true); }}
    />
  );
};
